const labelsData = [
  {
    id: 1,
    small_heading: "Step 1",
    large_heading: "Your Info",
  },
  {
    id: 2,
    small_heading: "Step 2",
    large_heading: "Select Plans",
  },
  {
    id: 3,
    small_heading: "Step 3",
    large_heading: "Addons",
  },
  {
    id: 4,
    small_heading: "Step 4",
    large_heading: "Summary",
  },
];
export default labelsData;
